import React,{useState,useEffect} from "react";
import '../css/homePage.css';
function HeaderComponent(props) {
    const { eventData,openModal,openReadModal } = props;
    
     

    return (
        <>
    {(eventData ?
           <div className="nw18-left-content" id="about">
            {(eventData.logo ?
                        <div className="nw18-big-logo-div">
                            <a href="" title="">
                                <img src={(eventData.logo ? eventData.logo : '')} title="" alt="" />
                            </a>
                        </div>
                        : ''
            )}
                       
                        {/* {(eventData?.date ?
                            <div className="nw18-date-details-div">
                                <h2 className="nw18-details-div">
                                {(eventData?.date ? eventData.date+',' : '')}
                                    <span> {(eventData?.time ? eventData.time+', ': '')}</span>
                                    {(eventData?.location ? eventData.location : '')}
                                </h2>

                            </div>
                        : ''
                        )} */}
                        {/* <p className="nw18-digital-desc">
                            {eventData?.short_title}
                        </p>  */}
                        <p className="nw18-digital-desc">
                        Discover the extraordinary world of brands with Brand Blitz Quiz - India's First Panel Business Quiz by Storyboard18. Did you know that...</p>
                        <ul className="nw18-digital-desc">
                            <li>Netflix Cheating is when you watch a TV show ahead of your significant other </li>
                            <li>Hyundai Santro is named after the town of Saint Tropez in France</li>
                            <li>Twitter’s $8 charge for blue tick was inspired by a Monty Python comedy sketch</li>
                        </ul>
                        <p className="nw18-digital-desc">
                        If these nuggets interest you, then Brand Blitz is the quiz for you! If you love brands and how they work, if you are an ad geek, or just someone who loves trivia and listening to unheard stories, join the Brand Blitz Quiz.</p>
                        <p className="nw18-digital-desc">Prizes worth over 1.5 Lacs are up for grabs!

                        <span className="rdmrbtn" onClick={openReadModal}> Read More...</span>

 


                        {/* <span dangerouslySetInnerHTML={{ __html: eventData?.description }} /> */}
                            {/* {eventData?.description} */}
                        </p> 
                        <div className="nw18-agenda-btn-div">
                            <a href={void(0)} onClick={() => openModal(true)} title="Rules & Regulations" className="nw18-agenda-btn">Rules & Regulations</a>
                        </div>
                    </div>
                    
                    
                    : 
                        <div>
                            <p>Data not found</p>
                        </div>
                    )}
    

                    </>
                    

    )
}
export default HeaderComponent;